import React, { FC, memo } from 'react'
import { TrustItem, IconWrapper, TextContent, Label } from './styles'
import NextImage from '../../common/next-image'
import { useTranslation, useLocale } from '../../../hooks/locale'

export type TrustBarItemId = 'trustpilot' | 'accommodations' | 'bookings' | 'recommendations' | 'legacy'

export interface TrustBarItemData {
    id: TrustBarItemId
    icon: any
    translationKey: string
    number: number | null
    isImage?: boolean
}

interface TrustBarItemProps {
    item: TrustBarItemData
}

const TrustBarItem: FC<TrustBarItemProps> = ({ item }) => {
    const { t } = useTranslation()
    const { locale } = useLocale()
    const { id, icon, translationKey, number, isImage } = item

    if (isImage) {
        return (
            <TrustItem $isTrustPilotLogo>
                <IconWrapper $isTrustPilotLogo>
                    <NextImage src={icon} alt={id} objectFit="contain" />
                </IconWrapper>
            </TrustItem>
        )
    }

    const formattedNumber = number?.toLocaleString(locale)

    const IconComponent = icon

    return (
        <TrustItem>
            <IconWrapper>
                <IconComponent />
            </IconWrapper>
            <TextContent>
                <Label>
                    {formattedNumber} {t(translationKey)}
                </Label>
            </TextContent>
        </TrustItem>
    )
}

export default memo(TrustBarItem)
